import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslate } from '../../../components/TranslationText';
import EahsForm from '../../../components/EahsForm';
import { FormTextInput, FormSelect, FormYesNo } from '../../../components/FormInputs';
import { eformInput } from '../../../common/cssclasses';
import { FRANCE_ID } from '../constants/checkoutSchema';

/**
 * Covering Location section of the SemenCheckout form.
 * Reads coveringCountryId from FormProvider context to conditionally
 * require center name/number when France is selected.
 *
 * @param {Array} countries - Country options for select
 * @param {boolean} disabled - Disable all inputs (view-only)
 */
export default function SemenCoveringLocation({ countries, disabled = false }) {
    const { translate } = useTranslate();
    const { watch } = useFormContext();
    const coveringCountryId = watch('coveringCountryId');
    const isForExport = watch('isForExport');
    const isFrance = coveringCountryId === FRANCE_ID;

    return (
        <EahsForm
            key="coveringLocation"
            title={translate('web.coveringLocation', 'Covering Location')}

        >
            <div className={eformInput}>
                <FormYesNo
                    name="isForExport"
                    label={translate('web.isSemenForExport', 'Is Semen For Export?')}
                    required
                    disabled={disabled}
                />
            </div>
            <div className={eformInput}>
                <FormSelect
                    name="coveringCountryId"
                    label={translate('web.coveringCountry', 'Covering Country')}
                    options={countries}
                    required={isForExport}
                    disabled={disabled}
                />
            </div>
            <div className="col-md-3 col-sm-12 col-12 mb-form-group">
                <FormTextInput
                    name="centerName"
                    label={translate('web.centerName', 'Center Name')}
                    required={isFrance}
                    disabled={disabled}
                />
            </div>
            <div className="col-md-3 col-sm-12 col-12 mb-form-group">
                <FormTextInput
                    type="number"
                    name="centerNumber"
                    label={translate('web.centerNumber', 'Center Number')}
                    required={isFrance}
                    disabled={disabled}
                />
            </div>
        </EahsForm>
    );
}
